import { addendumRequestsTyped } from "@/api/(requests)/addendumTyped";
import dayjs from "@/lib/helpers/dayjs";
import type { UUID } from "@/core/types";

export type UpdateNoteAddendumVariables = {
  addendum: string;
  addendumId: UUID;
  credentials: string | undefined;
  noteId: UUID;
  patientId: UUID;
  signature: string | undefined;
};

export function updateNoteAddendum({
  addendum,
  addendumId,
  credentials,
  noteId,
  patientId,
  signature,
}: UpdateNoteAddendumVariables) {
  return addendumRequestsTyped.update_note_addendum({
    body: {
      addendum,
      addendum_id: addendumId,
      credentials,
      note_id: noteId,
      signature,
      timestamp: dayjs().unix(),
    },
    context: { showLoader: false },
    urlParams: { patientId },
  });
}
